import React, { useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FetchDashboardMetrics } from "src/Thunk/adminThunks";


const Dashboard = () => {
  const dispatch = useDispatch();
  const { metrics } = useSelector((state) => state.admin);
  useEffect(() => {
    dispatch(FetchDashboardMetrics());
  }, []);

  return (
    <div>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 text-info">DASHBOARD </h4>
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="text-info breadcrumb-item active">
                        Dashboard
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-shadow rounded-lg border my-3">
                  <div className="card-body">
                    <Row className="mt-4">
                      {metrics.map((itx) => (
                        <Col>
                          <div className="dashboard-card ">
                            <div>
                              <h5>Total {itx._id}</h5>
                              <div className="text-center">
                                <b style={{ color: "black", fontSize:"24px" }}>{itx.count}</b>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                     
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card custom-shadow rounded-lg border my-3">
                  <div className="card-body">
                    <Row className="mt-4">
                      <Col>
                        <div className="dashboard-card">
                          <Card.Body>
                            <h4>Doctor Mgmt</h4>
                            <Link
                              to="/doctorList"
                              className="btn btn-primary btn-sm"
                            >
                              Manage Doctors
                            </Link>
                          </Card.Body>
                        </div>
                      </Col>
                      <Col>
                        <div className="dashboard-card">
                          <Card.Body>
                            <h4>Patient Mgmt</h4>
                            <Link
                              to="/doctorList"
                              className="btn btn-primary btn-sm"
                            >
                              Manage Patients
                            </Link>
                          </Card.Body>
                        </div>
                      </Col>
                      <Col>
                        <div className="dashboard-card">
                          <Card.Body>
                            <h4>Specialities Mgmt</h4>
                            <Link to="/SpecialityList" className="btn btn-primary btn-sm">
                              Manage Specialities
                            </Link>
                          </Card.Body>
                        </div>
                      </Col>
                      <Col>
                        <div className="dashboard-card">
                          <Card.Body>
                            <h4>Appointment Mgmt</h4>
                            <Link to="" className="btn btn-primary btn-sm">
                              Manage Appointment
                            </Link>
                          </Card.Body>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-4"></Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
